import React from 'react';
import { autobind } from 'core-decorators';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import List from 'src/componentes/list';
import ListColumn from 'src/componentes/list/list-column';
import LucideIcon from 'src/componentes/lucide-icon';
import HoverCard from 'src/componentes/hover-card';

import PontoFaixaResultadoEdit from './edit';
import Preview from './preview';

@autobind
class PontosPorFaixaResultadoList extends React.Component {
  renderDescricao(item) {
    const { intl } = this.props;
    return (
      <div className="d-flex align-items-center">
        <span>{item.pontoFaixaResultado}</span>

        <HoverCard
          placement="left"
          className="tw:p-3"
          content={
            <>
              <div style={{ fontWeight: 'bold', marginBottom: 6, textAlign: 'center' }}>
                {intl.formatMessage({ id: 'label.pontosFaixaResultado' })}
              </div>
              <Preview model={item.pontoFaixaResultadoLookup} />
            </>
          }
        >
          <LucideIcon
            icon="information-outline"
            size={16}
            style={{ marginLeft: 6, cursor: 'pointer' }}
          />
        </HoverCard>
      </div>
    );
  }

  render() {
    let { model, intl, disabled, podeEditar } = this.props;

    return (
      <div>
        <List
          url="/ItemPontoFaixaResultado"
          showSearch={false}
          showTitle={true}
          title={intl.formatMessage({ id: 'label.pontosFaixaResultado' })}
          editComponent={PontoFaixaResultadoEdit}
          sort="dataInicio"
          parameters={{ ItemId: model.getModel('id').value }}
          showExport={false}
          showNew={!disabled && podeEditar}
          showEdit={!disabled && podeEditar}
          showDelete={!disabled && podeEditar}
          disabled={disabled}
          podeEditar={podeEditar}
          {...this.props}
        >
          <ListColumn
            headerText={intl.formatMessage({ id: 'idIntegracao' })}
            valueField="idIntegracao"
          />
          <ListColumn
            headerText={intl.formatMessage({ id: 'dataInicio' })}
            valueField="dataInicio"
          />
          <ListColumn
            headerText={intl.formatMessage({ id: 'dataTermino' })}
            valueField="dataTermino"
          />
          <ListColumn
            headerText={intl.formatMessage({ id: 'descricao' })}
            valueField="pontoFaixaResultado"
            valueFunction={this.renderDescricao}
          />

        </List>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}
export default injectIntl(
  connect(mapStateToProps)(PontosPorFaixaResultadoList)
);
